import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate} from "react-router-dom";
import { handleSecondaryClassificationSelect, setActiveFilterStep } from '../../redux/actions/siteSettingsActions'
import { classificationItemPropType } from '../../utils/propTypes';
import ViewHeader from '../../components/viewHeader/viewHeader';
import CarouselPicker from '../../components/carouselPicker/carouselPicker';
import { filterStepsTypes } from '../../appSettings';
import '../../styles/classificationsPicker.scss';
import './secondaryClassificationsView.scss';

const SecondaryClassificationsView = ({
  classifications,
  selectedPrimaryClassifications,
  selectedSecondaryClassifications,
  onSetActiveFilterStep,
  onHandleSecondaryClassificationSelect,
  labels,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUrlPrimaries = urlSearchParams.get('pc');

    /* 
      If no primary classifications was selected - route to #primary-classification
      Checking aginst the url to avoid having to wait for the urlState -> store state operation
    */
    if (selectedUrlPrimaries === '') {
      onSetActiveFilterStep(filterStepsTypes.PRIMARY_CLASSIFICATIONS);
      navigate(`/${filterStepsTypes.PRIMARY_CLASSIFICATIONS}`);
    }
  }, [])


  return (
    <section className="vf-view vf-classifications-view vf-sc-view">

    <ViewHeader header={labels.secondaryClassificationsHeader} subHeader={labels.secondaryClassificationsSubHeader} />

      <div className='sc-classifications-container'>
        { selectedPrimaryClassifications.map((primaryKey) => {
          const classificationHeader = classifications[primaryKey].displayName;
          const secondaryClassifications = classifications[primaryKey].children;
          return (
            <section key={primaryKey} className='vf-sc__section'>
              <p className='vf-sc__section-header'>{classificationHeader}</p>
              <CarouselPicker
                fullSize={false}
                allowToggleAll
                selectAllLabel={labels.secondaryClassificationsSelectAll}
                options={secondaryClassifications}
                selected={selectedSecondaryClassifications}
                onSelect={onHandleSecondaryClassificationSelect} />
            </section>
          )
        })}
      </div>
    </section>
  );
};

SecondaryClassificationsView.propTypes = {
  onSetActiveFilterStep: PropTypes.func.isRequired,
  onHandleSecondaryClassificationSelect: PropTypes.func.isRequired,
  classifications: PropTypes.objectOf(classificationItemPropType).isRequired,
  selectedPrimaryClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedSecondaryClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  labels: PropTypes.shape({
    secondaryClassificationsHeader: PropTypes.string.isRequired,
    secondaryClassificationsSubHeader: PropTypes.string.isRequired,
    secondaryClassificationsSelectAll: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    secondaryClassificationsHeader: attributeCollection.secondaryClassificationsHeader,
    secondaryClassificationsSubHeader: attributeCollection.secondaryClassificationsSubHeader,
    secondaryClassificationsSelectAll: attributeCollection.secondaryClassificationsSelectAll,
  }
  return {
    classifications: siteSettings.classifications,
    selectedPrimaryClassifications: siteSettings.filters.selectedPrimaryClassifications,
    selectedSecondaryClassifications: siteSettings.filters.selectedSecondaryClassifications,
    labels,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetActiveFilterStep: (step) => {
      dispatch(setActiveFilterStep(step));
    },
    onHandleSecondaryClassificationSelect: (classification) => {
      dispatch(handleSecondaryClassificationSelect(classification));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryClassificationsView);
